import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'

export default !function () {
  const block = document.querySelector('.success-stories-v1')

  if (!block) {
    return;
  }

  const sliderContainer = block.querySelector('.success-stories-v1__wrapper')
  const slides = sliderContainer.querySelectorAll('.success-stories-v1__item')
  const controls = sliderContainer.querySelector('.success-stories-v1__controls')
  const isInit = slides.length > 1

  const options = {
    wrapper: sliderContainer,
    lazy: true,
    settings: {
      spaceBetween: 8,
      effect: 'slide',
      loop: false,

      slideClass: 'success-stories-v1__item',
      wrapperClass: 'success-stories-v1__list',

      navigation: {
        nextEl: '.js-slider-next',
        prevEl: '.js-slider-prev'
      },
    },
    modules: ['navigation', 'a11y'],
    initCondition: {
      sm: isInit,
      md: isInit,
      lg: isInit,
      xl: isInit
    },
    controls
  }

  new Slider(options).init()
}()
